import { Box, Flex } from '@/components/atoms/Grid'
import { H2 } from '@/components/atoms/typography'
import PageContentWrapper from '@/components/organisms/pageContentWrapper'
import { FC, useEffect } from 'react'
import styled from 'styled-components'
import { validFor } from '../../theme'
import BlogPosts from '@/components/organisms/blog/blogPosts'
import BlogMainArticle from '@/components/organisms/blog/blogMainArticle'
import BlogNewsletterForm from '@/components/organisms/blog/blogNewsletterForm'
import { withBaseServerSideProps } from '@/HOC/withBaseServerSideProps'
import { getMainData } from '@/utils/mainDataHelper'
import { requestThrow401 } from '@/utils/graphQl'
import { Blog, Page } from '@/network/graphql.g'
import { useMhub } from '@/providers/mhubProvider'

type BlogProps = {
  blogs?: Blog[]
}

const BlogPage: FC<BlogProps> = ({ blogs = [] }) => {
  const { pushBlogPage } = useMhub()
  useEffect(() => {
    pushBlogPage()
  }, [])

  return (
    <StyledPageContentWrapper>
      <Flex
        justifyContent="flex-start"
        alignItems="center"
        flexDirection="column"
        width="100%"
      >
        <StyledH2>Fashion Blog</StyledH2>
        <BlogMainArticle mainArticle={blogs[0]} />
        <StyledBox>
          <BlogPosts blogPosts={blogs.slice(1)} />
          <BlogNewsletterForm />
        </StyledBox>
      </Flex>
    </StyledPageContentWrapper>
  )
}

export default BlogPage

const StyledPageContentWrapper = styled(PageContentWrapper)`
  max-width: 1000px;
  margin: 0 auto;
  padding-bottom: 56px;
  ${validFor.mobile` 
    padding: 0 0 56px; 
	`};
`

const StyledH2 = styled(H2)`
  font-weight: 700;
  text-transform: uppercase;
`

const StyledBox = styled(Box)`
  box-sizing: border-box;
  width: 100%;
  & > div {
    border-top: 1px solid ${(props) => props.theme.colors.onBackground};
  }
  ${validFor.mobile` 
    padding-inline: 28px; 
	`};
`

export const getServerSideProps = withBaseServerSideProps(
  async ({
    sdk,
    withMainNavigation,
    withStore
  }): Promise<GetServerSideProps<BlogProps>> => {
    const { success: blogSuccess, response: blogResponse } =
      await requestThrow401({
        method: sdk.getBlogData,
        variables: { page: Page.Blogs, withMainNavigation, withStore },
        mainResponse: (response) => response?.blogs
      })

    if (!blogSuccess) {
      return {
        notFound: true
      }
    }

    return {
      props: {
        mainData: getMainData(blogResponse),
        seoTags: blogResponse?.seoTags,
        blogs: blogResponse?.blogs
      }
    }
  }
)
